import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/configuracao/fiscais/FiscaisApiClient'

export default {
	async [actionTypes.CONFIGURACAO.FISCAIS.BUSCAR_FISCAIS]({ state }) {
		const { paginacao, filtro } = state
		const { data } = await api.buscarFiscais(paginacao, filtro)
		return data
	},
	async [actionTypes.CONFIGURACAO.FISCAIS.EXCLUIR_FISCAL](context, idFiscal) {
		await api.excluirFiscal(idFiscal)
	},
	async [actionTypes.CONFIGURACAO.FISCAIS.BUSCAR_ORGAOS](context, campoBusca) {
		const { data } = await api.buscarOrgaos({ campoBusca })
		return data
	},
	async [actionTypes.CONFIGURACAO.FISCAIS.BUSCAR_USUARIOS_FISCAIS](context, objParam) {
		const { data } = await api.buscarUsuariosFiscais(objParam)
		return data
	},
	async [actionTypes.CONFIGURACAO.FISCAIS.ADICIONAR_FISCAL](context, objParam) {
		const { data } = await api.adicionarFiscal(objParam)
		return data
	},
	async [actionTypes.CONFIGURACAO.FISCAIS.BUSCAR_ANEXOS](context, objParam) {
		const { idFiscal } = objParam
		const { data } = await api.buscarAnexos(idFiscal)
		return data
	},
	async [actionTypes.CONFIGURACAO.FISCAIS.BAIXAR_ANEXO](context, objParam) {
		const { idFiscal, idExterno } = objParam
		await api.baixarAnexo(idFiscal, idExterno)
	},
	async [actionTypes.CONFIGURACAO.FISCAIS.EDITAR_FISCAL](context, { idFiscal, body }) {
		const { data } = await api.editarFiscal(idFiscal, body)
		return data
	},
	async [actionTypes.CONFIGURACAO.FISCAIS.EXCLUIR_ANEXO_FISCAL](context, objParam) {
		return await api.excluirAnexoFiscal(objParam)
	},
}
